import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=040ca734&scoped=true"
import script from "./safe.vue?vue&type=script&lang=ts"
export * from "./safe.vue?vue&type=script&lang=ts"
import style0 from "./safe.vue?vue&type=style&index=0&id=040ca734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ca734",
  null
  
)

export default component.exports